import React from 'react';
import loadingIcon from './icon-windcreek-inverse.svg';
import './LoadingIndicator.css';

function LoadingIndicator({ expand, overlay, size, ...rest }) {
  const sizeClass = size ? ` size-${size}` : '';
  const indicator = (
    <div className={'loading-indicator' + sizeClass} {...rest}>
      <div className="loading-animation" />
      <img className="loading-mask" src={loadingIcon} alt="" />
    </div>
  );

  if (expand || overlay) {
    const wrapClass = 'loading-indicator-' + (overlay ? 'overlay' : 'expand');
    return <div className={wrapClass + sizeClass}>{indicator}</div>;
  } else {
    return indicator;
  }
}

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator/index.js